import * as React from 'react';
import { useSelector } from 'react-redux';

import { FloatingLabel } from 'shared/components/FloatingLabel';
import { selectDailyrentOfferData } from 'shared/selectors/offerData/selectDailyrentOfferData';
import { EOfferLabels } from 'shared/types/dailyrent';

import boltIcon from './assets/bolt.svg';

export function InstantBookingLabelContainer() {
  const dailyrent = useSelector(selectDailyrentOfferData);
  const offerLabels = dailyrent?.offerLabels || [];

  const showInstantBookingLabel = offerLabels.includes(EOfferLabels.InstantBooking);

  if (!showInstantBookingLabel) {
    return null;
  }

  return (
    <FloatingLabel
      data-testid="InstantBookingLabel"
      labelText="Мгновенная бронь"
      tooltipText="Это жильё можно забронировать без переговоров с владельцем и долгого ожидания подтверждения брони"
      color="accent-main-primary"
      backgroundColor="accent-main-secondary"
      icon={<img src={boltIcon} alt="" />}
    />
  );
}
